import { useFormik } from 'formik';
import * as Yup from 'yup';

export type Address = {
  postcode: string;
  line_1: string;
  line_2?: string;
  city: string;
};

export const validationSchema = Yup.object().shape({
  postcode: Yup.string().trim().required('Postcode is required'),
  line_1: Yup.string().trim().required('Address Line 1 is required'),
  line_2: Yup.string().trim().optional(),
  city: Yup.string().trim().required('City is required'),
});

export const useForm = (onSubmit: (values: Address) => Promise<void>) => {
  return useFormik<Address>({
    initialValues: {
      postcode: '',
      line_1: '',
      city: '',
    },
    validateOnBlur: true,
    onSubmit,
    validationSchema,
  });
};
